import React from "react";
import { education } from "../constants";

/* ═══════════════════════════════════════════════════════════
   EDUCATION — Luxury Academic Timeline
   Gold hairline · glass cards · liquid reveals
   ═══════════════════════════════════════════════════════════ */

const Education = () => {
  return (
    <div className="lux-container">
      <div className="max-w-3xl mb-20">
        <p className="lux-eyebrow mb-6">Academic Background</p>
        <h2 className="lux-heading">
          <span className="reveal-line">
            <span>Education</span>
          </span>
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {education.map((edu, i) => (
          <div key={`edu-${i}`} className="lux-card reveal-fade p-8">
            <div className="flex items-start justify-between mb-6">
              <div>
                <h3 className="font-grotesk text-lg font-medium text-silver-100">
                  {edu.degree}
                </h3>
                <p className="text-sm text-champagne-400 mt-2 tracking-wide">
                  {edu.institution}
                </p>
              </div>
              <span className="font-grotesk text-[0.65rem] tracking-[0.15em] uppercase text-silver-500 whitespace-nowrap">
                {edu.period}
              </span>
            </div>
            <div className="h-px bg-gradient-to-r from-champagne-500/30 to-transparent" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Education;